export default "__VITE_ASSET__9e265741__"